import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import * as d3 from 'd3';
import { LegendComponent } from '../legend/legend.component';
import { LayerParams } from '../map/layer-manager';

@Component({
  selector: 'app-landslide-legend-group',
  templateUrl: './landslide-legend-group.component.html',
  styleUrls: ['./landslide-legend-group.component.css']
})
export class LandslideLegendGroupComponent implements OnInit {

  isActive: {[key: string]: boolean} = {
    'cluster2': false,
    'cluster5': false,
    'cluster6': false,
    'cluster7': false,
    'altitude': false,
    'incident': false,
  };

  @ViewChild('altitudeLegend') altitudeLegend: LegendComponent;

  @ViewChild('incidentLegend') incidentLegend: LegendComponent;

  constructor() { }

  ngOnInit(): void {
  }

  getClusterColors(nCluster: number) {

    let colors = d3.schemeCategory10;
    return colors.slice(0, nCluster).reverse();
  }

  toggleLegend(legendId: string, status: boolean) {
    this.isActive[legendId] = status;
    this.isActive = this.isActive;
  }

  toggleAltitudeLegend(status: boolean, values: number[], valueType: string) {
    
    this.isActive['altitude'] = status;

    if (status == true) {
      this.altitudeLegend.update(['ALTITUDE'], values, valueType);
    }

    this.isActive = this.isActive;
  }

  toggleIncidentLegend(status: boolean, values: number[], valueType: string, 
    colorFn: (t: number) => string = d3.interpolateBlues) {

    this.isActive['incident'] = status;

    if (status == true) {
      this.incidentLegend.update(['OCORRÊNCIAS'], values, valueType, colorFn);
    }

    this.isActive = this.isActive;
  }

}
